import { Button, Image } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import brokenGem from '../assets/BrokenGem.svg'
import '../styles/notFoundStyles.css'
import { useNavigate } from 'react-router-dom'

const NotFoundPage = () => {
    const { t } = useTranslation()
    const navigate = useNavigate()

    return (
        <div className="notFoundPageContainer">
            <h2>ERROR <br/> <strong>404</strong></h2>
            <Image src={brokenGem}/>
            <p>{t('notFoundPageText')}</p>
            <div className="diamondsButtonContainer">
                <Button onClick={() => navigate('/')}>{t('returnToMainPage')}</Button>
            </div>
        </div>
    )
}

export default NotFoundPage